import React, { PureComponent } from 'react';
import { withCapoeiraSportState } from 'src/ver2/context';
import TrefaText from 'src/ver2/components/trefaText';
import ArticleLittle from './little';
import Pump from 'src/ver2/components/halloween';

import Loader from 'src/ver2/components/loader';

import { orderBy } from 'lodash';

import './styles.css';


class ArticlePage extends PureComponent {

    state = {
        article: null,
        mainArticle: null,
        childsArticles: null,
        subArticles: null,
        isLoaded: false
    }

    changeIsLoaded = (isLoaded = true) => { this.setState({ isLoaded }) }

    initLoadArticle = async () => {
        this.setState({ isLoaded: false })
        const { client } = this.props;
        const articleId = this.props.match.params.articleId;
        const articlesData = await client.articleConstructor({ ActionData: 'get', TargetId: articleId });

        if (!articlesData || !articlesData[0]) {
            return this.setState({
                article: null,
                isLoaded: true
            })
        }

        const article = articlesData[0];

        const { Id, MainId } = article;

        let mainArticle = null;
        let childsArticles = null;
        let subArticles = null;

        if (MainId) {
            mainArticle = await client.articleConstructor({ ActionData: 'get', TargetId: MainId }) || [];
            subArticles = await client.articleConstructor({ ActionData: 'get', Data: { MainId } });
            if (subArticles && subArticles.articles) {
                subArticles = subArticles.articles
            } else {
                subArticles = null;
            }
        }

        // смотрим, есть ли связки-дети
        childsArticles = await client.articleConstructor({ ActionData: 'get', Data: { MainId: Id } }) || [];
        if (childsArticles && childsArticles.articles) {
            childsArticles = childsArticles.articles
        } else {
            childsArticles = null;
        }
        /* 
                mainArticle: null,
                childsArticles: null,
                subArticles: null,
        */

        console.log(

        )

        return this.setState({
            article,
            isLoaded: true,
            mainArticle,
            childsArticles,
            subArticles
        })
    }

    componentDidMount() {
        this.initLoadArticle();
    }
    componentDidUpdate({ match }) {
        if (match.params.articleId !== this.props.match.params.articleId) {
            this.initLoadArticle();
        }
    }

    render() {

        const { isMobile } = this.props;

        const {
            isLoaded,
            article,
            mainArticle,
            childsArticles,
            subArticles
        } = this.state;

        const {
            ArticlesData
        } = this;

        if (!isLoaded) return <div className='article_page_main'>
            <Loader text='Загрузка статьи' />
        </div>
        if (!article) return <div className='article_page_main'>
            <span>
                {`К сожалению, такая статья не найдена :(`}
            </span>
        </div>

        const {
            Id,
            Theme,
            Body,
            Title,
            Date
        } = article

        if (isMobile) {
            return <div className='article_page_main'>
                {Id === 10 && <Pump width={40} left={150} top={5} pumpCode={'asuidg'} />}
                <h1>{Title}</h1>
                <div className='article_page_main_discription'>
                    <span>
                        {!!Theme && `#${Theme}`}
                    </span>
                    <span>
                        {Date}
                    </span>
                </div>
                <ArticlesData title={'ОСНОВНАЯ СТАТЬЯ'} articles={mainArticle} />
                <div className='article_page_main_text'>
                    <TrefaText trefaText={Body} />
                </div>
                <ArticlesData title={'ВНУТРЕННИЕ СТАТЬИ'} articles={childsArticles} />
                <ArticlesData title={'СМЕЖНЫЕ СТАТЬИ'} articles={subArticles} />

            </div>
        }

        return <div className='article_page_main'>
            {Id === 10 && <Pump width={40} left={200} top={30} pumpCode={'asuidg'} />}
            <div className='article_page_main_left'>
                <h1>{Title}</h1>
                <div className='article_page_main_discription'>
                    <span>
                        {!!Theme && `#${Theme}`}
                    </span>
                    <span>
                        {Date}
                    </span>
                </div>
                <div className='article_page_main_text'>
                    <TrefaText trefaText={Body} />
                </div>
            </div>

            <div className='article_page_main_right'>
                <ArticlesData title={'ОСНОВНАЯ СТАТЬЯ'} articles={mainArticle} />
                <ArticlesData title={'ВНУТРЕННИЕ СТАТЬИ'} articles={childsArticles} />
                <ArticlesData title={'СМЕЖНЫЕ СТАТЬИ'} articles={subArticles} />
            </div>
        </div>
    }

    ArticlesData = ({ title, articles }) => {

        if (!articles || !articles.length) return null;

        const articles_ = orderBy(articles, 'Pos')

        return <div className='article_page_main_right_articles'>
            <div className='article_page_main_right_article_title'>
                <span>{title}</span>
            </div>
            {
                articles_.map((article) => {
                    const { Id, Title } = article;
                    return <div key={`aak_${Id}`} className='article_page_main_right_article'>
                        <ArticleLittle article={article} />
                    </div>
                })
            }
        </div>
    }

}

export default withCapoeiraSportState('client, showInfoModal, iamuser, isMobile')(ArticlePage);